import React, { FC, useEffect, useState } from 'react';
import Content from './Content';
import './Frame.css';
import Navbar from './NavBar/NavBar';
import AuthContent from '../../Auth/AuthContent';
import { CustomButton, Loading } from '../../_common';
import { useStoreContext } from '../StoreProvider';
import moment from 'moment-timezone';
import { Modal, Row } from 'react-bootstrap';
import { useMutation } from '@apollo/client/react';

const Frame: FC = (): React.ReactElement => {
    const [state] = useStoreContext();
    const { auth } = state;
    moment.tz.setDefault('America/Chicago');

    const [showNotification, setShowNotification] = useState(false);
    const [notification, setNotification] = useState('');

    const userName = auth.user ? auth.user.profile.email : '';
    useEffect(() => {
        if (auth.user && !auth.user.expired) {
            if (auth.signalrConnection) {
                auth.signalrConnection
                    .start()
                    .then(result => {
                        console.log('Connecting to Notification Server');
                        if (auth.signalrConnection) {
                            auth.signalrConnection.invoke('AddToGroup', userName.toLowerCase()).catch(e => console.log('NotificationHub Error: ', e));
                            console.log('Connected ', userName, 'to the server');
                        }
                    })
                    .catch(e => console.log('Connection to Notification Server failed: ', e));
            }
        }
    }, [userName]);

    const signalrConnection = auth.signalrConnection;
    if (signalrConnection) {
        signalrConnection.on('NotificationReceived', (userName, message) => {
            setShowNotification(true);
            setNotification(message);
        });

        signalrConnection.on('NotificationRead', userName => {
            setShowNotification(false);
        });
    }

    document.addEventListener('visibilitychange', event => {
        if (!document.hidden) {
            if (signalrConnection?.state !== 'Connected') {
                signalrConnection &&
                    signalrConnection
                        .start()
                        .then(result => {
                            console.log('Connecting to Notification Server');
                            if (auth.signalrConnection) {
                                auth.signalrConnection.invoke('AddToGroup', userName.toLowerCase()).catch(e => console.log('NotificationHub Error: ', e));
                                console.log('Connected ', userName, 'to the server');
                            }
                        })
                        .catch(e => console.log('Connection to Notification Server failed: ', e));
            }
        }
    });

    const onClickClose = () => {
        if (signalrConnection)
            signalrConnection
                .invoke('NotificationRead', userName.toLowerCase())
                .then(params => {
                    console.log('Read Notification');
                })
                .catch(err => console.log('Error triggering the Notification Server: ', err.message));
        setShowNotification(false);
    };

    if (auth.isUserLoading) {
        return (
            <span className="Frame-Loading">
                <Loading />
            </span>
        );
    }

    if (auth.user && !auth.user.expired) {
        return (
            <div className="Frame-Container">
                <div className="Frame-Navigation">
                    <Navbar />
                </div>
                <div className="Frame-Content">
                    <Content />
                </div>

                <Modal show={showNotification} onHide={() => { }} dialogClassName="Notification-Setup-Container">
                    <Modal.Header className="Notification-Setup-Header">
                        <Modal.Title className="Notification-Setup-Header-Container">
                            <div className="Notification-Setup-Title">Inventory Alerts</div>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="Notification-Setup-Body">{notification.split('|')[0]}</div>
                        <div className="Notification-Setup-Jobnames">
                            {notification.split('|').map((jobName, index) => {
                                if (index !== 0)
                                    return (
                                        <div className="Notification-Setup-Jobname" key={index}>
                                            <i className="material-icons Notification-Setup-Jobname-Icon">
                                                fiber_manual_record
                                            </i>
                                            {jobName}
                                        </div>
                                    );
                            })}
                        </div>
                        <div className="Notification-Setup-Body">Please place these boxes in your inventory.</div>
                    </Modal.Body>

                    <Modal.Footer className="Notification-Setup-Footer">
                        <CustomButton title="Mark as Read" isBordered onClick={onClickClose} />
                    </Modal.Footer>
                </Modal>
            </div>
        );
    } else {
        return <AuthContent />;
    }
};

export default Frame;
